import React from 'react'
import { Container } from './styled'
import { SvgLoading } from '@ntuctech/devex-tangram/Icon'

const Loader = ({ isLoading }) => {
  return (
    <Container
      data-hidden={!isLoading}
      data-testid="loader"
      data-component="loader"
    >
      <SvgLoading size="l" color="#1454b8" />
    </Container>
  )
}

export default Loader
